module.exports = __webpack_public_path__ + "img/banner-male.35515bc2.jpg";